import React from 'react';
import PropTypes from 'prop-types';

import withStyles from '@material-ui/core/styles/withStyles';
import { LocalFlorist as EnvironmentalIcon, AccountBalance as HistoricIcon, FlashOn as PowerIcon, Category as AmenityIcon } from '@material-ui/icons';



import LayersIcon from '@material-ui/icons/Layers';
import { Skeleton } from '@material-ui/lab';

import { compose } from 'redux';
import { connect } from 'react-redux';
import { setFitBounds } from '../../../../redux/map/Actions';
import { MAIN_MAP } from '../../../../redux/map/Constants';
import { setOrCreateNewActiveLayer } from '../../../../redux/active_layers/Actions';

import LayerTableRow from './overview/LayerTableRow';
import Table from './Table';

class ConstraintTables extends React.Component {
    static propTypes = {
        classes: PropTypes.object.isRequired,
        constraints: PropTypes.array,
        valueLabel: PropTypes.string.isRequired,
        // Redux state
        layers: PropTypes.array.isRequired,
        layerSettings: PropTypes.array.isRequired,
        baseLayer: PropTypes.object.isRequired,
        // Redux dispatch
        dispatchSetFitBounds: PropTypes.func.isRequired,
        dispatchSetLayerActive: PropTypes.func.isRequired
    };

    constructor (props) {
        super(props);
        this.handleShowOnMap = this.handleShowOnMap.bind(this);
        this.buildTable = this.buildTable.bind(this);
    }

    handleShowOnMap (layerSystemName, bounds) {
        const { layers, dispatchSetFitBounds, dispatchSetLayerActive } = this.props;

        if (bounds) {
            const properties = {};
            switch (bounds.type) {
                case 'Polygon':
                    const coords = bounds.coordinates[0];
                    dispatchSetFitBounds([coords[0], coords[2]]);
                    break;
                case 'Line':
                    // TODO
                    break;
                case 'Point':
                    dispatchSetFitBounds([bounds.coordinates, bounds.coordinates], { maxZoom: 16 });
                    break;
            }

        }
        if (layerSystemName) {
            const layer = layers.find(layer => layer.system_name === layerSystemName);
            const activeLayer = {
                uid: layer.system_name,
                systemName: layer.system_name,
                visible: true,
                printable: true
            };
            dispatchSetLayerActive(activeLayer, layer);
        }
    }

    buildTable (constraints, title, icon) {
        const { layers, layerSettings, valueLabel } = this.props;
        const isLoading = !constraints;
        return (
            <Table
                key={title}
                headerTitle={title}
                headerIcon={icon}
                headings={['Type', 'Name', valueLabel, '']}
                skeleton={isLoading}
            >
                {
                    constraints && constraints.map(constraint => {
                        const layer = layers.find(layer => layer.id === constraint.layer.id);
                        const settings = layerSettings.find(setting => setting.uid === layer.system_name);
                        return (
                            <LayerTableRow
                                key={constraint.id}
                                layerSystemName={layer.system_name}
                                layerName={layer.name}
                                name={constraint.name}
                                type={constraint.type}
                                bounds={constraint.bounds}
                                value={constraint.value}
                                styling={layer.styles[(settings && settings.currentStyleIdx) || 0].mapboxStyleSpecification}
                                onShowOnMap={this.handleShowOnMap}
                            />
                        );
                    })
                }
            </Table>
        );
    }

    render () {
        const { classes, constraints } = this.props;

        const isLoading = !Boolean(constraints);

        if (isLoading) { return <Skeleton animation="wave" height={75} variant="rect" />; }

        const iconMap = {
            'Environmental': <EnvironmentalIcon />,
            'Historic': <HistoricIcon />,
            'Infrastructure': <PowerIcon />,
            'Amenity': <AmenityIcon />
        };

        const groupedConstraints = _(constraints)
            .groupBy(x => x.layer.category)
            .value();

        return (
            <>
                {
                    groupedConstraints &&
                        Object.keys(groupedConstraints).sort().map(key =>
                            this.buildTable(groupedConstraints[key], key, iconMap[key] || <LayersIcon />)
                        )
                }
            </>
        );
    }
}

const style = theme => ({

});

const mapStateToProps = (state) => {
    return {
        layers: state.layers.layers,
        layerSettings: state.layerSettingsReducer,
        baseLayer: state.layers.baseLayer
    };
};

const mapDispatchToProps = (dispatch) => ({
    dispatchSetFitBounds: (bounds, options = {}) => dispatch(setFitBounds(bounds, options, MAIN_MAP)),
    dispatchSetLayerActive: (activeLayer, layer) => dispatch(setOrCreateNewActiveLayer(activeLayer, layer))
});

export default compose(
    connect(mapStateToProps, mapDispatchToProps),
    withStyles(style)
)(ConstraintTables);